import { render, staticRenderFns } from "./country-card.vue?vue&type=template&id=66d4cbf0&scoped=true&"
import script from "./country-card.vue?vue&type=script&lang=js&"
export * from "./country-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d4cbf0",
  null
  
)

export default component.exports